import template from './testimonios.component.html';
import angular from 'angular';
import './testimonios.repository';
import 'owl.carousel';

angular
    .module('Toke')
    .component('appTestimonios', {
        template,
        bindings: {
            data: '<'
        },
        controller: TestimoniosController
    });


TestimoniosController.$inject = ['testimoniosRepository', '$timeout', '$element'];

function TestimoniosController(testimoniosRepository, $timeout, $element) {

    const vm = this;

    vm.testimonios = {};

    vm.$onInit = function () {

        if (vm.data && vm.data.list) {
            vm.testimonios = vm.data;
            initOwl()

        } else {
            testimoniosRepository.getTestimonios().then(res => {
                vm.testimonios = res || {};
                initOwl()
            });
        }
    };




    function initOwl() {
        $timeout(() => {
            const $owl = angular.element('.testimonio__owl');

            if ($owl.length && !$owl.hasClass('owl-loaded')) {
                $owl.owlCarousel({
                    items: 1,
                    loop: true,
                    dots: false,
                    nav: false,
                    autoplay: true,
                    margin: 16,
                    autoplayTimeout: 5000,
                    center: true,

                    responsive: {
                        0: {
                            items: 1
                        },
                        768: {
                            items: 2
                        },
                        992: {
                            items: 3,
                            margin: 24
                        }
                    }
                });
            }
        });
    }
}


